<!-- [x]: rendere la sezione un component generico -->
<header-pre-head></header-pre-head>

<a id="gb_focusable" href="#pagecontent" title="{{'section.header.labels.goToContent' | translate}}" attr.aria-label="{{'section.header.labels.goToContent' | translate}}" tabindex="0">
  {{'section.header.labels.goToContent' | translate}}
</a>
<a id="gb_focusableMenu" href="#" title="{{'section.header.labels.goToMenu' | translate}}" attr.aria-label="{{'section.header.labels.goToMenu' | translate}}" aria-controls="gb_mobimenu" tabindex="0">
  {{'section.header.labels.goToMenu' | translate}}
</a>

<!-- MOBILE -->
<div id="gb_mobimenu" class="gb_entemobimenu" aria-labelledby="gb_focusableMenu"
  [attr.aria-hidden]="!isGeneralMenuOpened" [ngClass]="{ 'opn': isGeneralMenuOpened }">
  <div class="gb_menucont">
    <div class="gb_headMenuMobi">
      <figure class="gb_brand m-0">
        <a href="javascript:void(0);" [routerLink]="['/']" title="Plug&Pay" tabindex="0" aria-label="Plug&Pay">
          <img src="assets/gb/img/logo-pap.svg" alt="Plug&Pay" width="451" height="293" aria-label="Plug" />
          <span class="gb-hidden-visually">Plug&Pay</span>
        </a>
      </figure>
      <!-- Close button -->
      <button type="button" title="{{'section.header.labels.closeMenu' | translate}}"
        attr.aria-label="{{'section.header.labels.closeMenu' | translate}}" tabindex="0"
        class="gb_closemenubtn gb-button-reset" (click)="openGeneralMenu()">
        <span>
          <em></em>
          <em></em>
          <em></em>
          <span class="gb-hidden-visually gb-speak">{{"section.header.labels.closeMenu" | translate}}</span>
        </span>
      </button>
    </div>
    <menu>
      <ul>
        <!-- [x]: paynow -->
        <li class="gb_topLink">
          <a href="javascript:void(0);" [routerLink]="['/paynow/pay']" title="{{'paynow-page-title' | translate}}" tabindex="0">{{'paynow-page-title' | translate}}</a>
        </li>
        <!-- [x]: contattaci -->
        <div class="gb_topLink">
          <a href="javascript:void(0);" [routerLink]="['/contacts/info']" title="{{'contacts-page-title' | translate}}" tabindex="0">{{'contacts-page-title' | translate}}</a>
        </div>
      </ul>
    </menu>
    <hr />
    <div class="text-center">
      <div class="w-75 m-auto">
        <app-module-language-mobile></app-module-language-mobile>
      </div>
    </div>
  </div>
</div>

<!-- DESKTOP -->
<header class="position-absolute w-100">
  <div class="container">
    <div class="row">
      <div
        class="col-12 gb_extHeader d-flex align-items-start align-items-md-center align-items-lg-start justify-content-between">
        <figure class="gb_brand m-0">
          <a href="javascript:void(0);" [routerLink]="['/']" title="Plug&Pay" tabindex="0" aria-label="Plug&Pay">
            <img src="assets/gb/img/logo-pap.svg" alt="Plug&Pay" width="451" height="293" aria-label="Plug" />
            <span class="gb-hidden-visually">Plug&Pay</span>
          </a>
        </figure>
        <nav>
          <div class="gb_bottomLink">
            <app-module-language></app-module-language>
            <!-- [x]: paynow -->
            <ul>
              <li>
                <a href="javascript:void(0);" [routerLink]="['/paynow/pay']" title="{{'paynow-page-title' | translate}}" tabindex="0">{{'paynow-page-title' | translate}}</a>
              </li>
            </ul>
            <!-- Menu button -->
            <button type="button" title="Menu" aria-label="Menu" tabindex="0"
              class="gb_hambmenubtn gb-button-reset d-block d-lg-none" (click)="openGeneralMenu()">
              <span>
                <em></em>
                <em></em>
                <em></em>
                <span class="gb-hidden-visually gb-speak">Menu</span>
              </span>
            </button>
          </div>
           <!-- [x]: contattaci -->
          <div class="gb_topLink">
            <a href="javascript:void(0);" [routerLink]="['/contacts/info']" title="{{'contacts-page-title' | translate}}" tabindex="0">{{'contacts-page-title' | translate}}</a>
          </div>
        </nav>
      </div>
    </div>
  </div>
</header>
